import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-center" }
const _hoisted_2 = { class: "pt-6" }




export default /*#__PURE__*/_defineComponent({
  __name: 'Loader',
  props: {
  text: {
    type: String,
    required: false,
  },
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_progress_circular, {
      indeterminate: "",
      color: "green",
      size: 60,
      width: 6
    }),
    _createElementVNode("p", _hoisted_2, _toDisplayString(__props.text), 1)
  ]))
}
}

})